const messages: Record<string, string> = {
  // ── App shell ────────────────────────────────────────────────────────────────
  'app.title': 'holisTICK',
  'app.nav.daily': 'Daily',
  'app.nav.statistics': 'Statistics',
  'app.nav.statsShort': 'Stats',
  'app.nav.home': 'Go to today',
  'app.nav.habitStats': 'Habit stats',
  'app.nav.viewMenu': 'Switch view',
  'app.theme.switchToLight': 'Switch to light mode',
  'app.theme.switchToDark': 'Switch to dark mode',

  // ── Daily tracker ─────────────────────────────────────────────────────────────
  'daily.prevDay': 'Previous day',
  'daily.nextDay': 'Next day',
  'daily.selectDate': 'Select date',
  'daily.habits.title': 'Habits',
  'daily.habit.add': 'Add habit',
  'daily.habit.edit': 'Edit habit',
  'daily.habit.select': 'Habit',
  'daily.habits.empty': 'Build the routines that shape your day. Add a habit you want to stick with.',
  'daily.habits.emptyExample': 'e.g. Drink 8 glasses of water or Stretch for 10 minutes.',
  'daily.habits.emptyShort': 'Add a habit',
  'daily.notes.placeholder': 'A quick place to capture whatever is on your mind: an idea, a win, a worry, a to-do you do not want to lose.',
  'daily.notes.placeholderExample': 'e.g. Great chat with Mia today. Follow up about the proposal Friday.',
  'daily.notes.placeholderShort': 'Start typing',
  'daily.tasks.empty': 'Nothing on your plate yet. Nice. When something comes up, add it here to stay on top of your day.',
  'daily.tasks.emptyExample': 'e.g. Call the dentist or Finish slide deck for Monday.',
  'daily.tasks.emptyShort': 'Add a task',
  'daily.focus.placeholder': 'What do you want this month to be about? Set one theme to guide your choices.',
  'daily.focus.placeholderExample': 'e.g. Get stronger or Ship the side project.',
  'daily.focus.placeholderShort': 'Start typing',
  'daily.habits.count': '{completed}/{total}',
  'daily.habits.allDone': 'All habits ticked',
  'daily.habits.expand': 'Show habits',
  'daily.habits.collapse': 'Hide habits',
  'daily.notes.dailyTitle': 'Daily note',
  'daily.notes.habitName': 'Daily note',
  'daily.notes.edit': 'Edit daily note',
  'daily.notes.limit': 'You have reached the {max} character limit',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.loading': 'Loading',

  // Tasks list
  'daily.tasks.title': 'Tasks',
  'daily.tasks.add': 'Add task',
  'daily.tasks.quickAdd': 'New task',
  'daily.tasks.completed': '{count} completed',
  'daily.tasks.count': '{completed}/{total}',
  'daily.tasks.allDone': 'All tasks done',
  'daily.tasks.expand': 'Show tasks',
  'daily.tasks.collapse': 'Hide tasks',
  'daily.tasks.recurringBadge': 'Recurring',
  'daily.tasks.deleteTitle': 'Delete',
  'daily.tasks.editTitle': 'Edit',
  'daily.tasks.deleteRepeatingTitle': 'Delete repeating task',
  'daily.tasks.deleteRepeatingBody': 'This is a repeating task. What would you like to delete?',
  'daily.tasks.deleteOccurrence': 'This one',
  'daily.tasks.deleteSeries': 'All',

  // Task modal
  'daily.todoModal.editTitle': 'Edit Task',
  'daily.todoModal.newTitle': 'New Task',
  'daily.todoModal.fieldTitle': 'Title',
  'daily.todoModal.titlePlaceholder': 'What needs to be done?',
  'daily.todoModal.fieldTime': 'Time',
  'daily.todoModal.repeat': 'Repeat',
  'daily.todoModal.recNone': 'None',
  'daily.todoModal.recDaily': 'Daily',
  'daily.todoModal.recWeekly': 'Weekly',
  'daily.todoModal.recBiweekly': 'Biweekly',
  'daily.todoModal.recMonthly': 'Monthly',
  'daily.todoModal.recCustom': 'Custom',
  'daily.todoModal.dayOfMonth': 'Day of month',
  'daily.todoModal.every': 'Every',
  'daily.todoModal.days': 'days',
  'daily.todoModal.weeks': 'weeks',
  'daily.todoModal.daySu': 'Su',
  'daily.todoModal.dayMo': 'Mo',
  'daily.todoModal.dayTu': 'Tu',
  'daily.todoModal.dayWe': 'We',
  'daily.todoModal.dayTh': 'Th',
  'daily.todoModal.dayFr': 'Fr',
  'daily.todoModal.daySa': 'Sa',
  'daily.todoModal.save': 'Save',
  'daily.todoModal.create': 'Create',
  'daily.todoModal.onComplete': 'When completed',
  'daily.todoModal.onCompleteArchive': 'Archive',
  'daily.todoModal.onCompleteDelete': 'Delete it',
  'daily.todoModal.requiredTitle': 'Enter a title before saving.',
  'daily.todoModal.timeConfirm': 'Set',

  // One-off task modal

  // Daily schedule
  'daily.cal.title': 'Daily schedule',

  // Progress
  'daily.progress.label': '{completed} of {total} done',
  'daily.progress.count': '{completed} of {total}',
  'daily.progress.fraction': '{completed}/{total}',

  'daily.focus.title': 'Monthly focus',
  'daily.focus.edit': 'Edit monthly focus',

  // Layout settings
  'daily.settings.title': 'Daily Page Settings',
  'daily.settings.sections': 'Sections',
  'daily.settings.habits': 'Habits',
  'daily.settings.notes': 'Daily note',
  'daily.settings.tasks': 'Tasks',
  'daily.settings.calendar': 'Daily schedule',
  'daily.settings.focus': 'Monthly focus',
  'daily.settings.show': 'Show',
  'daily.settings.hide': 'Hide',
  'daily.datePicker.label': 'Date picker',
  'daily.datePicker.prevMonth': 'Previous month',
  'daily.datePicker.nextMonth': 'Next month',
  'daily.datePicker.today': 'Today',
  'daily.datePicker.dayProgress': '{day}, {completed} of {total} done',
  'daily.cal.allDay': 'All day',
  'daily.cal.habitTag': 'Habit',
  'daily.cal.taskTag': 'Task',
  'daily.cal.calTag': 'Cal',
  'daily.cal.overdue': 'Overdue',
  'daily.cal.connectBtn': 'Connect Google Calendar',
  'daily.cal.disconnectBtn': 'Disconnect',
  'daily.cal.connectedBadge': 'Google Calendar',
  'daily.cal.addToGcal': 'Add to Google Calendar',
  'daily.cal.removeFromGcal': 'Remove from Google Calendar',

  // Recurrence badge labels
  'daily.rec.daily': 'Daily',
  'daily.rec.weekly': 'Weekly',
  'daily.rec.biweekly': 'Biweekly',
  'daily.rec.monthly': 'Monthly',
  'daily.rec.intervalDays': 'Every {every} days',
  'daily.rec.intervalWeeks': 'Every {every} weeks',

  // ── Monthly tracker ───────────────────────────────────────────────────────────

  // Add-habit form
  'monthly.addForm.namePlaceholder': 'Habit name',
  'monthly.addForm.add': 'Add',
  'monthly.addForm.temporary': 'Temporary habit',
  'monthly.addForm.temporaryTooltip': 'This is a temporary tracker and it won\'t be displayed on the yearly tracker summary',

  // Column-edit popover
  'monthly.popover.editTitle': 'Edit habit',
  'monthly.popover.name': 'Name',
  'monthly.popover.colour': 'Colour',
  'monthly.popover.customColour': 'Custom colour',
  'monthly.popover.type': 'Type',
  'monthly.popover.typeCheckbox': 'Checkbox',
  'monthly.popover.typeRating': 'Rating',
  'monthly.popover.typeText': 'Text',
  'monthly.popover.calTime': 'Daily schedule time',
  'monthly.popover.clearTime': 'Clear time',
  'habit.error.duplicateName': 'A habit with this name already exists',
  'habit.error.saveFailed': 'Couldn\'t save. Please try again.',
  'notes.toolbar.bold': 'Bold',
  'notes.toolbar.italic': 'Italic',
  'notes.toolbar.highlight': 'Highlight',
  'notes.toolbar.bullets': 'Bullet list',
  'notes.toolbar.fontSmall': 'Smaller text',
  'notes.toolbar.fontNormal': 'Normal text',
  'notes.toolbar.fontLarge': 'Larger text',
  'monthly.popover.deleteHabit': 'Delete habit',
  'habit.delete.confirm': 'Are you sure you want to remove {name}?',
  'habit.delete.confirmTitle': 'Delete habit',
  'habit.delete.confirmProgress': 'This will delete all of its tracked progress.',
  'habit.delete.confirmStats': 'It will also disappear from yearly statistics.',
  'habit.delete.confirmAction': 'Delete',
  'habit.deleted': 'Habit was deleted',
  'habit.undo': 'Undo',
  'toast.habit.added': 'New habit added',
  'toast.habit.saveFailed': 'Error saving habit',
  'toast.habit.deleted': 'Habit was deleted',
  'toast.task.added': 'New task added',
  'toast.task.saveFailed': 'Error saving task',
  'toast.note.saved': 'Note saved',
  'toast.note.saveFailed': 'Error saving note',
  'toast.focus.saved': 'Monthly goal updated',
  'toast.focus.saveFailed': 'Error saving monthly goal',
  'monthly.popover.save': 'Save',

  // ── Yearly tracker ────────────────────────────────────────────────────────────

  // ── Habits (yearly detail) ────────────────────────────────────────────────────
  'habits.selectAll': 'Select all',
  'habits.deselectAll': 'Deselect all',
  'habits.noHabits': 'No trackable habits found.',
  'habits.selectPrompt': 'Select one or more habits to view the yearly grid.',
  'habits.done': 'Done',
  'habits.notDone': 'Not done',
  'habits.noRating': 'No rating',
  'habits.avg': 'Avg',

  // ── Yearly tasks ────────────────────────────────────────────────────────────

  // ── Monthly read-only view ──────────────────────────────────────────────────
  'year.monthly.noHabits': 'No trackable habits found.',
  'year.monthly.previousMonth': 'Previous month',
  'year.monthly.nextMonth': 'Next month',
  'year.monthly.dayColumn': 'Day',

  // ── Tasks year view ─────────────────────────────────────────────────────────
  'year.tasks.noTasks': 'No completed tasks found for this year',

  // ── Notes list view ─────────────────────────────────────────────────────────
  'year.notes.noNotes': 'No notes found for this month',
  'year.notes.dateColumn': 'Date',
  'year.notes.noteColumn': 'Note',

  // ── Stats navigation & headers ──────────────────────────────────────────────
  'app.nav.stats.habits': 'Habits',
  'app.nav.stats.tasks': 'Tasks',
  'app.nav.stats.notes': 'Notes',
  'stats.switch.yearly': 'Yearly',
  'stats.switch.monthly': 'Monthly',
  'stats.habits.previousYear': 'Previous year',
  'stats.habits.nextYear': 'Next year',
  'stats.tasks.previousYear': 'Previous year',
  'stats.tasks.nextYear': 'Next year',
  'stats.notes.previousMonth': 'Previous month',
  'stats.notes.nextMonth': 'Next month',
  'stats.export.csv': 'Export CSV',

  // ── Quick settings ─────────────────────────────────────────────────────────
  'settings.title': 'Quick settings',
  'settings.subtitle': 'Appearance & language',
  'settings.themeLabel': 'Theme',
  'settings.darkMode': 'Dark mode',
  'settings.lightMode': 'Light mode',
  'settings.themeLight': 'Light',
  'settings.themeDark': 'Dark',
  'settings.bgLabel': 'Background',
  'settings.bgHint': 'Paper tone used across the app',
  'settings.reset': 'Reset',
  'settings.langLabel': 'Language',
  'settings.langHint': 'Choose the interface language',
  'settings.layoutLabel': 'Layout',
  'settings.layoutHint': 'Rearrange daily sections',
  'settings.layoutChange': 'Change layout',
  'settings.open': 'Open settings',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteAccount.confirmTitle': 'Delete your account?',
  'settings.deleteAccount.confirmBody': 'Your account and all of your habits, progress, tasks and notes will be permanently deleted in 30 days. Sign in before then if you change your mind.',
  'settings.deleteAccount.confirmAction': 'Delete account',
  'settings.deleteAccount.error': 'Could not delete your account. Check your connection and try again.',
  'account.pending.title': 'Your account is scheduled for deletion',
  'account.pending.body': 'Everything will be permanently deleted on {date}. Restore your account to keep your data.',
  'account.pending.restore': 'Restore account',
  'account.pending.restoring': 'Restoring…',
  'account.pending.error': 'Could not restore your account. Check your connection and try again.',
  'legal.privacy': 'Privacy policy',
  'legal.terms': 'Terms of use',
  'legal.agreePrefix': 'By continuing you agree to the',
  'legal.and': 'and',
  'legal.back': 'Back to Holistick',

  // ── Auth ───────────────────────────────────────────────────────────────────
  'auth.subtitle': 'Sign in to track your day',
  'auth.languageQuestion': 'Choose your language',
  'auth.signInGoogle': 'Sign in with Google',
  'auth.signInApple': 'Sign in with Apple',
  'auth.signOut': 'Sign out',
  'auth.or': 'or',
  'auth.emailPlaceholder': 'your@email.com',
  'auth.sendMagicLink': 'Send sign-in code',
  'auth.sending': 'Sending…',
  'auth.magicLinkSent': 'Check your email for a sign-in code. Paste it below, or click the link if your email includes one.',
  'auth.codePlaceholder': 'Sign-in code',
  'auth.verifyCode': 'Sign in',
  'auth.verifying': 'Signing in…',
  'auth.changeEmail': 'Use a different email',
  'auth.resendCode': 'Resend code',
  'auth.genericError': 'Something went wrong. Please try again.',

  // ── Onboarding ─────────────────────────────────────────────────────────────
  'onboarding.language.title': 'Choose your language',
  'onboarding.language.subtitle': 'You can change this later in settings',
  'onboarding.language.label': 'Language',
  'onboarding.language.optionEnglish': 'English',
  'onboarding.language.optionUkrainian': 'Ukrainian',
  'onboarding.common.next': 'Next',
};

export default messages;
